// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const TourTooltipCorner = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M80 0C80 0 53.5 17.4304 49.5 81L44.8075 15.5138H0C60 11.7911 80 0 80 0Z" fill="#212121" />
    </svg>
  );
};
